import { MonoTypeOperatorFunction } from 'rxjs';
import { auditTime } from 'rxjs/operators';
import { AnimationFrameSchedulerDelegate, getAnimationFrameScheduler } from './animationFrameScheduler';

/** Schedules an animation frame and then emits the most recent value. */
export function auditInAnimationFrame<T>(
  window: AnimationFrameSchedulerDelegate,
): MonoTypeOperatorFunction<T> {
  const scheduler = getAnimationFrameScheduler(window);
  return auditTime(0, scheduler);
}
